import { Trello } from "./types/trello"

const PUP_DISPLAY_NAME = "Quickbooks"
const PUP_ID = "8"
const QUERY_LIMIT = 100

const CAPABILITY_PROPS = {
  baseUrl: import.meta.env.VITE_BASE_URL ?? "",
  logo: {
    dark: "/static/qb-glyph.svg",
    light: "/static/qb-glyph.svg"
  },
  icon: {
    dark: "/static/qb-glyph.svg",
    light: "/static/qb-glyph.svg"
  },
  authorizeIcon: {
    dark: "/static/authorize-icon.svg",
    light: "/static/authorize-icon.svg"
  }
}

const HELP_ACTION = {
  icon: "https://trello.bluedashersoftware.com/static/help.svg",
  alt: "help",
  position: "right" as "right" | "left",
  callback: (t: Trello.PowerUp.IFrame) => {
    return t.popup({
      title: "Help Center",
      url: "./help.html",
      height: 300
    })
  }
}

export {
  PUP_DISPLAY_NAME,
  PUP_ID,
  CAPABILITY_PROPS,
  HELP_ACTION,
  QUERY_LIMIT
}
